import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import NewCampaign from "./pages/NewCampaign";
import BulkPreorder from "./pages/BulkPreorder";
import CampaignDetail from "./pages/CampaignDetail";
import Storefront from "./pages/Storefront";
import StorefrontHub from "./pages/StorefrontHub";
import StorefrontLaunches from "./pages/StorefrontLaunches";
import StorefrontPreorders from "./pages/StorefrontPreorders";
import StorefrontJustDropped from "./pages/StorefrontJustDropped";
import StorefrontApply from "./pages/StorefrontApply";
import CutApplications from "./pages/CutApplications";
import CutBrand from "./pages/CutBrand";
import { CutLanding, CutLeaderboardPage, CutWinnersPage, CutJourneyPage, CutPressPage } from "./pages/CutPublic";
import { CutAdminRounds, CutAdminRoundDetail, CutAdminBrandEditor } from "./pages/CutAdmin";
import StorefrontCompetitions from "./pages/StorefrontCompetitions";
import StorefrontReelsList from "./pages/StorefrontReelsList";
import StorefrontRound from "./pages/StorefrontRound";
import StorefrontReel from "./pages/StorefrontReel";
import LoginPage from "./pages/LoginPage";
import Rounds from "./pages/Rounds";
import NewRound from "./pages/NewRound";
import RoundDetail from "./pages/RoundDetail";
import Reels from "./pages/Reels";
import NewReel from "./pages/NewReel";
import ReelDetail from "./pages/ReelDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { borderRadius: "12px", border: "1px solid #E4E5E7", fontFamily: "Inter" },
            }}
          />
          <Routes>
            <Route path="/" element={<Navigate to="/app" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/app" element={<Dashboard />} />
              <Route path="/app/campaigns/new" element={<NewCampaign />} />
              <Route path="/app/campaigns/bulk" element={<BulkPreorder />} />
              <Route path="/app/campaigns/:id" element={<CampaignDetail />} />
              <Route path="/app/rounds" element={<Rounds />} />
              <Route path="/app/rounds/new" element={<NewRound />} />
              <Route path="/app/rounds/:id" element={<RoundDetail />} />
              <Route path="/app/reels" element={<Reels />} />
              <Route path="/app/reels/new" element={<NewReel />} />
              <Route path="/app/reels/:id" element={<ReelDetail />} />
              <Route path="/app/applications" element={<CutApplications />} />
              <Route path="/app/the-cut" element={<CutAdminRounds />} />
              <Route path="/app/the-cut/:id" element={<CutAdminRoundDetail />} />
              <Route path="/app/the-cut/:id/:brandId" element={<CutAdminBrandEditor />} />
            </Route>
            <Route path="/storefront" element={<StorefrontHub />} />
            <Route path="/storefront/launches" element={<StorefrontLaunches />} />
            <Route path="/storefront/preorders" element={<StorefrontPreorders />} />
            <Route path="/storefront/just-dropped" element={<StorefrontJustDropped />} />
            <Route path="/storefront/apply" element={<StorefrontApply />} />
            <Route path="/storefront/competitions" element={<StorefrontCompetitions />} />
            <Route path="/storefront/reels" element={<StorefrontReelsList />} />
            <Route path="/storefront/rounds/:id" element={<StorefrontRound />} />
            <Route path="/storefront/reels/:id" element={<StorefrontReel />} />
            <Route path="/storefront/:id" element={<Storefront />} />
            <Route path="/the-cut" element={<CutLanding />} />
            <Route path="/the-cut/leaderboard" element={<CutLeaderboardPage />} />
            <Route path="/the-cut/winners" element={<CutWinnersPage />} />
            <Route path="/the-cut/me" element={<CutJourneyPage />} />
            <Route path="/the-cut/press" element={<CutPressPage />} />
            <Route path="/the-cut/:slug" element={<CutBrand />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
